import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthUser } from '@/types/State';

export interface AuthState {
  isLoadingUser: boolean;
  user: AuthUser | null;
}

const initialState: AuthState = {
  isLoadingUser: true,
  user: null,
};

export const sessionExpired = createAction('auth/sessionExpired');

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthUser | null>) => {
      state.user = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoadingUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sessionExpired, (state) => {
      state.user = null;
      state.isLoadingUser = false;
    });
  },
});

export const { setUser, setIsLoading } = authSlice.actions;
export default authSlice.reducer;
